/* @ngInject */
function BrandController ($scope, $q, $timeout, $rootScope, $translate, UdsModalService, BrandService) {
  const getBrandSectionFormDialogController = () => $q.when(import('./dialogs/brand-section-form/brand-section-form-dialog.controller'))

  $scope.flags = {
    loading: true,
    searching: false,
    scrollingBySidebar: false
  }
  $scope.sections = []
  $scope.selectedSectionId = null
  $scope.getBrandSectionIconByType = BrandService.getBrandSectionIconByType

  const api = {
    getBrandSectionFormDialogController,
    _handleSuccessGetBrandSections,
    _handleErrorGetBrandSections,
    _observeSections,
    _verifyIntersectionAtSection,
    _getHeader,
    _searchAssets,
    _openNewSectionDialog
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getHeader()
    BrandService.getBrandSections().then(api._handleSuccessGetBrandSections).catch(api._handleErrorGetBrandSections)
  }

  const deregisterReloadBrandSections = $scope.$on('reloadBrandSections', () => {
    $scope.flags.loading = true
    $scope.sections = []
    if (!$scope.$$phase) $scope.$apply()
    BrandService.getBrandSections().then(api._handleSuccessGetBrandSections).catch(api._handleErrorGetBrandSections)
  })

  const deregisterBrandSectionsLoaded = $scope.$on('brand-sections-loaded', event => {
    api._observeSections(event)
  })

  $scope.$on('$destroy', () => {
    deregisterReloadBrandSections()
    deregisterBrandSectionsLoaded()
  })

  $scope.handleSectionPress = function (section) {
    $scope.flags.scrollingBySidebar = true
    const $container = $('.brand-content-container')
    const $target = $('#brand-section-' + section.id)

    const containerOffset = $container.offset()?.top || 0
    const targetOffset = $target.offset().top - containerOffset + $container.scrollTop()

    $container.stop(true, false).animate(
      { scrollTop: targetOffset },
      {
        duration: 300,
        easing: 'swing',
        complete: () => {
          $scope.flags.scrollingBySidebar = false
          $scope.$apply()
        }
      }
    )

    $timeout(() => {
      $scope.selectedSectionId = section.id
    }, 0, true)
  }

  function _openNewSectionDialog () {
    $('.sidebar-menu-second-level').transition('slide down')
    api.getBrandSectionFormDialogController().then(({ BrandSectionFormDialogController }) => {
      const dialog = UdsModalService.createModal({
        controller: BrandSectionFormDialogController,
        modalName: 'brandSectionFormDialog',
        onClose: (section) => {
          if (section) {
            $scope.sections.push(section)
          }
        }
      })

      dialog.open()
    })
  }

  $scope.openNewSectionDialog = api._openNewSectionDialog

  function _searchAssets (term) {
    if (term) {
      $scope.flags.searching = true
    } else {
      $scope.flags.searching = false
    }
    $scope.$broadcast('searchAssets', term)
  }

  function _handleSuccessGetBrandSections (sections) {
    $scope.sections = sections
    $scope.flags.loading = false
  }

  function _handleErrorGetBrandSections () {
    $scope.flags.loading = false
  }

  function _observeSections ({ targetScope }) {
    const sectionElement = document.querySelector(`[data-section="${targetScope.section.id}"`)

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1
    }

    const observer = new IntersectionObserver(api._verifyIntersectionAtSection, options)

    if (sectionElement) {
      observer.observe(sectionElement)
    }
  }

  function _verifyIntersectionAtSection ([entry]) {
    if (entry.isIntersecting && !$scope.flags.scrollingBySidebar) {
      $timeout(() => {
        const sectionId = parseInt(entry.target.dataset.section, 10)
        $scope.selectedSectionId = sectionId
      })
    }
  }

  function _getHeader () {
    $scope.headerToolbar = {
      search: {
        onSearch: api._searchAssets
      }
    }

    if ($rootScope.isUserSysAdminAdminDesigner()) {
      $scope.headerToolbar.rightButtons = [{
        type: 'button',
        btnType: 'primary',
        icon: 'plus',
        label: $translate.instant('brand.newSection'),
        onClick: api._openNewSectionDialog
      }]
    }
  }
}

export { BrandController }
